<template>
  <div :class="[
    'autocomplete position-relative',
    {
      'autocomplete-selected': selected,
    }
  ]">
    <input type="hidden" :name="name" v-model="selectedEncoded">

    <div
      class="position-absolute mt-5 results-container"
      v-if="!selected && (searching || searched || showNotFoundError)"
    >
      <div class="list-group">
        <span class="list-group-item searching" v-if="searching">
          <span class="media">
            <span class="media-left">
              <i class="fa fa-circle-o-notch fa-spin mr-1"></i>
              Searching...
            </span>
          </span>
        </span>
        <span class="list-group-item no-results" v-if="showNotFoundError">
          <span class="media">
            <span class="media-left">
              <i class="fa fa-ban mr-1"></i>
              No matches found.
            </span>
          </span>
        </span>
        <a
          v-for="(result, i) in results"
          :key="`result_${i}`"
          href="#"
          class="list-group-item list-group-item-action"
          @click.prevent="select(result)"
        >
          <slot name="result">
            <span class="media">
              <span class="media-left mr-3">
                <i :class="'fa ' + parse(result).icon"></i>
              </span>
              <span class="media-body">
                {{ parse(result).name }}
              </span>
            </span>
          </slot>
        </a>
      </div>
    </div>

    <input
      v-if="!selected"
      :id="id"
      v-model="query"
      type="text"
      class="position-relative form-control input-lg"
      :placeholder="placeholder"
      :readonly="readonly"
      @focus="onFocus"
      @blur="onBlur"
    >

    <div class="form-control" v-if="selected">
      <div class="media">
        <div class="media-body">
          <slot name="selected">
            <span class="media">
              <span class="media-left mr-3">
                <i :class="'fa ' + parse(selected).icon"></i>
              </span>
              <span class="media-body">
                {{ parse(selected).name }}
              </span>
            </span>
          </slot>
        </div>
        <div class="media-right">
          <a
            v-if="!readonly"
            href="#"
            @click.prevent="clear()"
          >
            <i class="fa fa-close"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.results-container {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1050;
  -webkit-box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.18);
  -moz-box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.18);
  box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.18);
  max-height: 50vh;
  overflow: scroll;
}
</style>

<script>
import _ from 'lodash'
import axios from 'axios'

export default {
  props: {
    url: {
      type: String,
      default: null,
    },
    search: {
      type: Function,
      default: function (query) {
        return axios.post(this.url, query)
      }
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default () {
        return null
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    encode: {
      type: Boolean,
      default: true
    },
    prepare: {
      type: Function,
      default: function (query) {
        return {
          search: query
        }
      }
    },
    parse: {
      type: Function,
      default: function (result) {
        return result
      }
    },
    placeholder: {
      type: String,
      default: null
    },
    searchOnFocus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      results: [],
      query: '',
      searched: false,
      searching: false,
      selected: this.value
    }
  },
  computed: {
    selectedEncoded () {
      if (this.encode) {
        return this.selected ? JSON.stringify(this.selected) : 'null'
      } else {
        return this.selected
      }
    },
    showNotFoundError () {
      return !this.searching && this.searched && this.query.length > 0 && this.results.length < 1
    }
  },
  watch: {
    value () {
      this.selected = this.value
      this.query = ''
    },
    query () {
      if (this.query) {
        this.doSearch(this.query)
      } else {
        this.searched = false
        this.searching = false
        this.results = []
      }
    }
  },
  methods: {
    onFocus () {
      this.doSearch(this.query)
    },
    onBlur () {
      setTimeout(() => {
        this.searching = this.searched = false
        if (!this.selected) {
          this.query = ''
        }
      }, 200)
    },
    select (result) {
      this.$emit('selected', result)
      this.selected = result
      this.$emit('input', this.selected)
    },
    clear () {
      this.selected = null
      this.$emit('input', null)
    },
    doSearch: _.debounce(function (query) {
      if (query || this.searchOnFocus) {
        this.searched = false
        this.searching = true
        this.search(this.prepare(query))
          .then((response) => {
            this.results = response.data
            this.searched = true
            this.searching = false
          })
          .catch((error) => {
            console.error(error)
          })
      }
    }, 300)
  }
}
</script>